module.exports = __webpack_public_path__ + "img/code-icon.4adc98c5.svg";